import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RestService } from '../rest/rest.service';
import { RestOptions } from '../rest/rest-request';
import { TickerResponse } from '../../domain/public-api';

@Injectable({
  providedIn: 'root'
})
export class TickersRestService {
  constructor(private restService: RestService) {
  }

  getTickers(symbol: Array<string>): Observable<Array<TickerResponse>> {
    const parameters: RestOptions = {
      params: { symbol }
    };
    return this.restService.getResource('markets.indicators').get<{ data: Array<TickerResponse> }>(parameters).pipe(
      map((response: { data: Array<TickerResponse> }): Array<TickerResponse> | undefined => response?.data ?? undefined)
    );
  }
}

